import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { trackPromise } from "react-promise-tracker";
import { useSnackBar } from "../../../../hooks/snackBar";
import ListProdutoLogSeller from "./ListProdutoLogSeller";
import { saveAs } from "file-saver";
import {
  gerarExelModeloBaseImportacao,
  listarLogProdutosSeller,
  gerarExportacaoResultadoLog,
  importarProdutos,
  gerarExelModeloBaseImportacaoProduto,
} from "../../../../services/http/SellerAdminstradorService/categoriaProdutoSellerService";

import "./styles.scss";

const ImportacaoProdutoSeller = () => {
  const history = useHistory();
  const { addSnackBar } = useSnackBar();
  const hiddenFileInput = React.useRef(null);
  const stateRef = useRef();

  const [documento, setDocumento] = useState(null);
  const [voltou, setVoltou] = useState(false);
  stateRef.current = voltou;
  const [logProdutos, setProdutosLog] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const carregarListaProdutosLog = (pagina) => {
    trackPromise(
      listarLogProdutosSeller(pagina).then((res) => {
        if (res.data) {
          setProdutosLog(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar log de produtos",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar carregar log de produtos",
        info: "error",
        open: true,
      });
    });
  };

  const exportarResultadoLogProduto = (tipoLogResultado, idLog) => {
    trackPromise(
      gerarExportacaoResultadoLog(tipoLogResultado, idLog).then((res) => {
        if (res.data) {
          saveAs(res.data, "log-produtos.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível baixar log de produtos",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar baixar log de produtos",
        info: "error",
        open: true,
      });
    });
  };

  const gerarModeloBaseImportacao = () => {
    var idSeller = JSON.parse(sessionStorage.getItem("authSistema")).idSeller;
    trackPromise(
      gerarExelModeloBaseImportacaoProduto(idSeller).then((res) => {
        if (res.data) {
          saveAs(res.data, "modelo-base-produtos.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível baixar modelo base",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar baixar modelo base",
        info: "error",
        open: true,
      });
    });
  };

  const importarArquivo = () => {
    var emailUsuario = JSON.parse(sessionStorage.getItem("authSistema")).email;

    if (!documento) {
      addSnackBar({
        message: "Você deve selecionar primeiro um arquivo",
        info: "warning",
        open: true,
      });
      return;
    }

    trackPromise(
      importarProdutos(documento, emailUsuario).then(async (res) => {
        if (res.data) {
          setDocumento(null);
          addSnackBar({
            message: "Importado com sucesso",
            info: "success",
            open: true,
          });
          carregarListaProdutosLog(1);
        } else if (res.fail) {
          var erro = "Não foi possível importar produtos: ";

          var errors = JSON.parse(await res.errors.text());
          errors.forEach((element) => {
            erro += element.menssagem + ". ";
          });

          addSnackBar({ message: erro, info: "warning", open: true });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar importar produtos",
        info: "error",
        open: true,
      });
      setTimeout(() => {
        const closeButton = document.querySelector(
          ".MuiButtonBase-root.MuiButton-root.MuiButton-text"
        );
        if (closeButton) {
          closeButton.click();
        }
      }, 2000);
    });
  };

  const reprocessarArquivo = (registro) => {
    if (!documento) {
      addSnackBar({
        message: "O arquivo original não está disponível.",
        info: "warning",
        open: true,
      });
      return;
    }

    const emailUsuario = JSON.parse(
      sessionStorage.getItem("authSistema")
    ).email;

    trackPromise(
      importarProdutos(documento, emailUsuario).then((res) => {
        if (res.data) {
          addSnackBar({
            message: "Reprocessado com sucesso.",
            info: "success",
            open: true,
          });

          // Atualiza o estado com as novas informações
          setProdutosLog((prevState) => ({
            ...prevState,
            lista: prevState.lista.map((item) =>
              item.id === registro.id
                ? {
                    ...item,
                    dataHoraImportacao: new Date().toISOString(),
                    usuario: emailUsuario,
                  }
                : item
            ),
          }));
        } else {
          addSnackBar({
            message: "Erro ao tentar reprocessar o arquivo.",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ao tentar reprocessar o arquivo.",
        info: "error",
        open: true,
      });
    });
  };

  const mudarPaginaProdutoLog = (page) => {
    carregarListaProdutosLog(page);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleUpload = (event) => {
    var file = event.target.files[0];

    if (!file) {
      setDocumento(null);
      return;
    }

    if (!file.name.endsWith(".xlsx")) {
      addSnackBar({
        message: 'Você deve selecionar um arquivo com extensão ".xlsx"',
        info: "warning",
        open: true,
      });
      setDocumento(null);
      return;
    }

    setDocumento(file);
  };

  const voltar = () => {
    setVoltou(true);
  };

  useEffect(() => {
    carregarListaProdutosLog(1);
  }, []);

  return (
    <div>
      <div className="row">
        <h1 className="col-sm-12 col-md-12 col-lg-12 titulo">Produtos</h1>
      </div>

      <div className="row mt20 ml-1">
        <h1 className="label-second">Importação de Produtos</h1>
      </div>

      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3">
          <input
            type="file"
            ref={hiddenFileInput}
            multiple
            style={{ display: "none" }}
            onChange={handleUpload}
          />

          <button
            className="button-anexar buton-green btn btn-block btn-lg"
            type="file"
            style={{ width: "100%" }}
            onClick={handleClick}
          >
            {documento?.name ? "ALTERAR ARQUIVO" : "ESCOLHER ARQUIVO"}
          </button>

          {/* Exibir arquivo selecionado */}
          {documento && (
            <div className="text-file">
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 72 72"
                id="emoji"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="color">
                  <path
                    fill="#b1cc33"
                    d="m61.5 23.3-8.013-8.013-25.71 25.71-9.26-9.26-8.013 8.013 17.42 17.44z"
                  />
                </g>
                <g id="line">
                  <path
                    fill="none"
                    stroke="#000"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                    d="m10.5 39.76 17.42 17.44 33.58-33.89-8.013-8.013-25.71 25.71-9.26-9.26z"
                  />
                </g>
              </svg>
              <span className="file-name">{documento.name}</span>
            </div>
          )}
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3">
          <button
            onClick={importarArquivo}
            className="buton-white-black-border btn btn-block btn-lg"
            disabled={!documento}
          >
            IMPORTAR ARQUIVO
          </button>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3 d-flex align-items-start mt-2">
          <strong onClick={gerarModeloBaseImportacao}>
            <u>BAIXAR MODELO</u>
          </strong>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 mt-4">
          <p className="pteste">
            <strong>Orientações</strong>
            <br />
            Para fazer o upload em massa do seu estoque, siga as orientações
            abaixo:
          </p>
          <ul>
            <li>
              Clique em "Baixar Modelo" para fazer o download da planilha de
              importação;
            </li>
            <li>A planilha deve estar no formato .xlsx;</li>
            <li>As células devem estar no formato GERAL;</li>
            <li>O arquivo não deve conter células mescladas;</li>
            <li>A primeira linha deve conter o cabeçalho das colunas;</li>
            <li>Deve haver somente uma aba no arquivo;</li>
            <li>
              Após a importação, veja o resultado de cada registro clicando nos
              números processados;
            </li>
            <li>
              No caso de erro no upload, será gerada uma planilha com o
              descritivo do erro de leitura na última coluna. Favor consultar,
              ajustar e carregar novamente.
            </li>
          </ul>
        </div>
      </div>
      <div className="mt20">
        <ListProdutoLogSeller
          response={logProdutos}
          mudarPagina={mudarPaginaProdutoLog}
          exportarLog={exportarResultadoLogProduto}
          reprocessarArquivo={reprocessarArquivo}
        />
      </div>
      <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
        <button
          className="col-sm-4 col-md-4 col-lg-4 mt20 buton-white-black-border"
          onClick={() => history.push("/produto")}
        >
          VOLTAR
        </button>
      </div>
    </div>
  );
};

export default ImportacaoProdutoSeller;
